import {
  Container,
} from "@mui/material";
import {useUserData} from "@/hooks/use-user-data-provider";
import {FilloutStandardEmbed} from "@fillout/react";

export function ContactPage() {
  const {user} = useUserData();
  
  return (
    <Container maxWidth="md" sx={{py: 8}}>
      <FilloutStandardEmbed filloutId={'12qfU1iU1dus'} parameters={{
        name: user?.name,
        email: user?.email,
        userName: user?.name,
        userId: user?.id,
        organizationId: user?.organizationId,
        organizationName: user?.organization?.name,
      }} inheritParameters={true}
                            dynamicResize={true}/>
    </Container>
  );
}
